module.exports = __webpack_public_path__ + "img/icone_fechar_cinza.0ffce2e0.svg";